module.exports = __webpack_public_path__ + "img/ctm-new-tab-icon.55ed0312.svg";